<template>
  <div class="md-layout md-alignment-top-center">
    <md-card>
      <md-card-header>Manuelle Aktivität hinzufügen
      </md-card-header>
      <md-card-content>
        <ValidationObserver v-slot="{ handleSubmit }" ref="validator">
        <form @submit.prevent="handleSubmit(submitForm)">
          <div class="md-layout">
            <div class="md-layout-item md-size-100">
              <label style="display: flex">Bitte lade hier ein Screenshot von deiner Aktivität hoch, auf dem man deine Zeit und die Distanz deutlich erkennen kann und trage diese Daten hier manuell ein.</label>
              <drag-and-drop-component
                  :current-images="activityImage"
                  :titleImage="activity.titleImage"
                  :allow-multiple="false"
                  @updateTitleImage="updateTitleImage($event)"
                  @photoSet="updateTitleImage($event)">
              </drag-and-drop-component>
            </div>
            <div class="md-layout-item md-size-50 md-medium-size-100">
              <label class="dots bold">Sportsart</label>
              <md-field>
                <md-select
                    v-model="activity.activityType"
                    disabled
                    name="activityType"
                >
                  <md-option
                      v-for="item in activityTypes"
                      :key="item.number"
                      :label="item.label || item.type"
                      :value="item.number"
                  >
                    {{ item.label || item.typeitem.type }}
                  </md-option>
                </md-select>
              </md-field>
            </div>
            <div class="md-layout-item md-size-50 md-medium-size-100">
              <ValidationProvider
                  name="start"
                  rules="required"
                  v-slot="{ passed, failed }"
              >
                <div class="challenge-date-time" style="display:flex">
                  <label class="dots bold">Start</label>
                  <md-field class="challenge-date-time">
                    <datetime
                        type="datetime"
                        v-model="activity.start"
                        input-class="form-control"
                        :min-datetime="minDatetime"
                        :max-datetime="maxDatetime"
                        format="dd:MM.yyyy HH:mm"
                    ></datetime>
                    <slide-y-down-transition>
                      <md-icon class="error" v-show="failed">close</md-icon>
                    </slide-y-down-transition>
                    <slide-y-down-transition>
                      <md-icon class="success" v-show="passed">done</md-icon>
                    </slide-y-down-transition>
                  </md-field>

                </div>
              </ValidationProvider>
            </div>
            <div class="md-layout-item md-size-50 md-medium-size-100">
              <label class="dots bold">Titel</label>
              <div class="md-layout-item" style="padding: 0 !important;">
                <ValidationProvider
                  name="title"
                  rules="required"
                  v-slot="{ passed, failed }"
              >
                <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]" style="padding-right: 35px;">
                  <md-input v-model="activity.title" type="text"></md-input>
                </md-field>
                <slide-y-down-transition class="validate-icons">
                  <md-icon class="error" v-show="failed">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition class="validate-icons">
                  <md-icon class="success" v-show="passed">done</md-icon>
                </slide-y-down-transition>
              </ValidationProvider>
              </div>
            </div>
            <div class="md-layout-item md-size-50 md-medium-size-100">
              <label class="dots bold">Dauer</label>
              <div style="display:flex; flex-direction: column">
              <div class="md-layout">
                <div class="md-layout-item md-size-10 md-xsmall-size-15 custom-style">
                  <ValidationProvider
                      name="hours"
                      rules="min_value:0|max_value:23"
                      v-slot="{ passed, failed }"
                  >
                    <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
                      <md-input v-model="duration.hours" @keypress="isNumber($event)" placeholder="0" class="t-r"></md-input>
                    </md-field>
                  </ValidationProvider>
                </div>
                <span class="dots">:</span>
                <div class="md-layout-item md-size-10 md-xsmall-size-15 custom-style">
                  <ValidationProvider
                      name="minutes"
                      rules="min_value:0|max_value:59"
                      v-slot="{ passed, failed }"
                  >
                    <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
                      <md-input v-model="duration.minutes" @keypress="isNumber($event)" placeholder="0" class="t-r">
                      </md-input>
                    </md-field>
                  </ValidationProvider>
                </div>
                <span class="dots">:</span>
                <div class="md-layout-item md-size-10 md-xsmall-size-15 custom-style">
                  <ValidationProvider
                      name="seconds"
                      rules="min_value:0|max_value:59"
                      v-slot="{ passed, failed }"
                  >
                    <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
                      <md-input v-model="duration.seconds" @keypress="isNumber($event)" placeholder="0" class="t-r">
                      </md-input>
                    </md-field>
                  </ValidationProvider>
                </div>
                <span class="dots description-info">(hh : mm : ss)</span>
              </div>
              <span v-if="showErrorMessage.duration" class="not-allowed-time">Dauer sollte größer als 0 sein</span>
              </div>
            </div>
            <div class="md-layout-item md-size-50 md-medium-size-100">
              <label class="dots bold">Distanz in Meter</label>
              <div class="md-layout">
                <div class="md-layout-item md-size-60" style="padding: 0 !important;">
                  <md-field>
                    <md-input v-model="activity.data.distanceInMeters" @keypress="isNumber($event)" placeholder="0" class="t-r">
                    </md-input>
                  </md-field>
                  <span v-if="showErrorMessage.distance" class="not-allowed-time">Distanz sollte größer als 0 sein</span>
                </div>
                <div class="md-layout-item" style="display: flex">
                  <span class="dots description-info">({{formatM2Km(activity.data.distanceInMeters||0)}})</span>
                </div>
              </div>
            </div>
            <div class="md-layout-item md-size-50 md-medium-size-100">
              <label class="dots bold">Pace</label>
              <md-field>
                <md-input :value="formatPace(speedInKm)" disabled></md-input>
              </md-field>
            </div>
          </div>
        </form>
        </ValidationObserver>
      </md-card-content>
      <md-card-actions>
        <md-button class="mr-5 cancel-button" @click="goToRoute(`/Challenges/${challenge._id}`)">
          Schließen
        </md-button>
        <md-button class="md-success" @click="submitForm">
          Speichern
        </md-button>
      </md-card-actions>
    </md-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
import activity from '@/utils/activity';
import datetime from "@/utils/datetime";
import validation from "@/utils/validation";


import { extend } from 'vee-validate';
import { max_value, min_value, required } from "vee-validate/dist/rules";
import { Datetime } from "vue-datetime";
// import DragAndDropComponent from '../../atomic-design/molecules/drag-and-drop-component'
import DragAndDropComponent from 'sports4me-web_components/atomic-design/molecules/drag-and-drop-component'
import debounce from '@/utils/debounce';

extend("required", required);
extend("min_value", min_value);
extend("max_value", max_value);

export default {
  components: {
    datetime: Datetime,
    DragAndDropComponent
  },
  data() {
    return {
      id: this.$route.params.id,
      challenge: null,
      // @TODO: refactor to one big object for my RegData
      additionalFormFields: null,
      additionalFormData: null,
      started: false,
      finished: false,
      urlCode: this.$route.query['code'] || this.$route.query['join-code'] || this.$route.query['voucher'] || undefined,
      urlPaymentResult: this.$route.query["payment-result"] || undefined, // value: 'success' or 'cancel'
      urlJoined: this.$route.query["joined"],
      urlProcessId: this.$route.query["process-id"],
      joinFormFields: [],
      myData: null,
      // resultDocuments: [],
      // updatedChallengeRegistration: {},
      components: {lb:null},
      showEditButton: false,
      canAddManualActivity: false,
      activity: {
        images: [],
        activityType: null,
        durationInSeconds: null,
        data: {
          distanceInMeters: null,
          averagePaceInMinutesPerKilometer: null
        },
      },
      showManualActivityDialog: false,
      activityTypes: activity.getActivitiesWithValidData(),
      activityImage: null,
      duration: {
        hours: undefined,
        minutes: undefined,
        seconds: undefined
      },
      speedInKm: 0,
      minDatetime: null,
      maxDatetime: null,
      distanceInKm: 0,
      showErrorMessage: { duration: true, distance: true},
      leaderboardKey: 0,
      myDiscipline: null,
      myCode: null,
      landingPage: undefined,
      height: '0px',
      doResize: debounce(() => {
        this.stretch = false;
        this.$nextTick(() => {
          if (this.$refs.sliderItems) {
            this.height = Math.max(...(this.$refs.sliderItems.map(el => el.getBoundingClientRect().height))) + 'px';
          }
          this.stretch = true;
        });
      }, 600),
      stretch: false,
    };
  },
  computed: {
    ...mapState({
      userId: state => state.user && state.user._id,
      isAdmin: state => state.isAdmin || false
    }),
    hasJoined() {
      return (
        this.challenge &&
        !!this.challenge.joined.find(u => u.userId === this.userId)
      );
    },
    hasFinished() {
      return (
        this.challenge &&
        !!this.challenge.joined.find(u => u.userId === this.userId)
      );
    },
    hasInvitation() {
      return (
          this.challenge &&
          !!this.challenge.invited.find(u => u.userId === this.userId)
      );
    }
  },
  watch: {
    $route(to, from) {
      this.id = to.params.id;
    },
    challenge() {
      if (this.hasJoined) {
        this.loadMyData();
      }
      // this.loadChallengeResultDocuments();
    },
    activity: {
      deep: true,
      handler(v) {
        // this.distanceInKm = formatM2Km(this.activity.data.distanceInMeters);
        this.showErrorMessage.distance = (!this.activity.data.distanceInMeters > 0);
        this.showErrorMessage.duration = (!this.activity.durationInSeconds > 0);

        if (this.activity.data.distanceInMeters > 0 && this.activity.durationInSeconds > 0) {
          this.speedInKm = this.calMin4Km(this.activity.durationInSeconds, this.activity.data.distanceInMeters)
        } else {
          this.speedInKm = undefined
        }
      }
    },
    duration: {
      deep: true,
      handler(val){
        this.activity.durationInSeconds = this.calculateTimeInSeconds();
      }
    },
    durationInSeconds(val) {
      if (val > 0) {
        this.showErrorMessage.duration = false;
      }
    },
  },
  destroyed() {
    window.removeEventListener("resize", this.doResize);
  },
  created() {
    window.addEventListener("resize", this.doResize);
    this.filterChallengeValues = this.challenge;
  },
  async mounted() {
    this.doResize();

    // remove query params like 'code' and 'join-code' and 'voucher' and 'payment-result'
    if (Object.keys(this.$route.query).length) {
      this.$router.replace(this.$route.path);
    }

    this.loadChallenge();

    if (this.urlPaymentResult === "success") {
      if (this.urlProcessId) {
        let statusResult;
        try {
          statusResult = await this.$api.checkOrderStatus(this.urlProcessId);
        } catch (e) {}
        if ( !statusResult || !statusResult.orderStatus || statusResult.orderStatus === "submitted" ) {
          this.$notify({
            timeout: 0,
            message:
              "Leider ist bei der Verarbeitung der Bestellung ein Fehler aufgetreten. Unser Team wurde verständigt und arbeitet an der Behebung des Problems. Bitte kontaktiere gegebenenfalls unseren Support.",
            icon: "add_alert",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger"
          });
          return;
        }
      }
    }

    if (this.urlJoined === "true") {
      this.$notify({
        timeout: 0,
        message:
          "Danke du hast dich erfolgreich zur Challenge angemeldet und erhältst eine Bestätigung per Mail.",
        icon: "add_alert",
        horizontalAlign: "right",
        verticalAlign: "top",
        type: "success"
      });
      window.scrollTo(0, 0);
    } else if (this.urlPaymentResult === "success") {
      this.$notify({
        timeout: 0,
        message:
          "Danke für deine Bestellung, du erhältst eine Bestätigung per Mail.",
        icon: "add_alert",
        horizontalAlign: "right",
        verticalAlign: "top",
        type: "success"
      });
      window.scrollTo(0, 0);
    };
  },
  methods: {
    ...datetime,
    ...activity,
    ...validation,
    gotToRoute(path) {
      this.$router.push("/Challenges/" + this.challenge._id + "/cart");
    },
    editJoinFrom() {
      this.$router.push(this.challenge._id + '/edit-registration')
    },
    updateTitleImage(data) {
      this.activity.titleImage = data;
    },
    exportResults() {
      this.$store.dispatch("exportResults", this.challenge._id);
    },
    // loadChallengeResultDocuments() {
    //   // @TODO remove it here - or pass the docs to the Leaderboard, cause it's also loaded
    //   this.$store
    //       .dispatch("loadChallengeResultDocuments", {
    //         challengeId: this.challenge._id
    //       })
    //       .then(res => {
    //         this.resultDocuments = res;
    //       });
    // },
    loadChallenge() {
      this.$store
        .dispatch("queryAPI", {url: "/rest/challenge/" + this.id + "?v=1"})
        .then(res => {
          this.challenge = res;
          this.minDatetime = res.start;
          this.maxDatetime = res.end;
          this.started = ( (new Date()) > (new Date(res.start)) );
          this.finished = (res.finished) ? true : ((new Date(res.end)) < (new Date()));
        })
        .catch(err => {
          this.$notify({
            timeout: 5000,
            message: err.message,
            icon: "add_alert",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger"
          });
        });
    },
    loadMyData() {
      if (this.hasJoined) {
        this.$store
          .dispatch("loadMyLeaderboard", {
            challengeId: this.challenge._id
          })
          .then(res => {
            if (res.discipline) {
              if (this.challenge && this.challenge.disciplines) {
                this.myDiscipline = this.challenge.disciplines.find(d => d.name === res.discipline);
                // set default values for manuel activity
                this.activity.activityType = this.myDiscipline.activityType;
                this.activity.title = this.getActivityLabel(this.myDiscipline.activityType) + ' für ' + this.challenge.title;
              }
            }
            if (res.result) {
              this.myData = res.result;
              this.myData.disciplineName = res.disciplineName;
              // activity
              this.canAddManualActivity = res.canAddActivity && !(this.challenge.finished||false); // check if challenge starts already
              // check if user can edit his registration
              this.showEditButton = this.challenge && this.challenge.joinForm && this.challenge.joinForm.fields.length
                  && (this.myData && (!this.myData.time && !this.myData.rank))
                  // && (!this.resultDocuments || (this.resultDocuments && !this.resultDocuments.length))
                  && this.finished != true;
            }
            if (res.code) this.myCode = res.code;
            const joinForm = this.challenge.joinForm.fields || [];
            const overrideFields = res.data || [];
            this.additionalFormData = res.additionalFormData || [];
            //empty pre-filled fields we get from the challenge join form
            let emptiedFields = joinForm.map(formField => {
              let emptiedField = null;
              if (formField.name && formField.value) {
                emptiedField = { ...formField, value: null };
              }
              if (formField.name=="code") {
                emptiedField = { ...formField, disabled: true }
              }
              return emptiedField ? { ...formField, ...emptiedField } : formField;
            });
            this.joinFormFields = emptiedFields.map(formField => {
              const overrideField = overrideFields.find(
                  f => f.name && formField.name === f.name
              );
              return overrideField
                  ? { ...formField, ...overrideField }
                  : formField;
            });
          });
      }
    },

    joinInvitation(hasAccepted) {
      if (this.challenge && this.challenge._id) {
        const url = hasAccepted
            ? `/rest/challenge/${this.challenge._id}/joined/me`
            : `/rest/challenge/${this.challenge._id}/reject/me`;

      this.$store
          .dispatch("postAPI", {
            url: url,
            method: "PUT",
            data: null
          })
          .then(res => {
            this.$emit("closeMe");
            this.challenge = res;
            if (!hasAccepted) {
              this.$router.push('/Challenges');
            }
            this.$notify({
              timeout: 5000,
              message: "Erfolgreich angemeldet",
              type: "success",
              horizontalAlign: "right",
              verticalAlign: "top",
            });
          })
          .catch(err => {
            this.$notify({
              timeout: 5000,
              message: err.message,
              type: "error",
              horizontalAlign: "right",
              verticalAlign: "top",
            });
          });
      }
    },
    submitForm() {
      this.$refs.validator.validate();
      this.activity.externalDataSourceId = 40;
      this.activity.images = this.activityImage;
      const body = { url: '/rest/activity/createForMe', data: this.activity };

      this.$refs.validator.validate().then(res => {
        if(!this.activity.durationInSeconds > 0) {
          this.showErrorMessage.duration = true;
          return;
        }
        if(!this.activity.data.distanceInMeters > 0) {
          this.showErrorMessage.distance = true;
          return;
        }
        if (res) {
          this.$store
              .dispatch("postAPI", {
                url: body.url,
                data: body.data
              })
              .then(res => {
                this.loadMyData();
                this.leaderboardKey++;
                this.$notify({
                  timeout: 5000,
                  message: "Erfogleicht bearbeitet",
                  type: "success",
                  horizontalAlign: "right",
                  verticalAlign: "top",
                });
                this.gotToRoute('/Challenges/' + this.challenge._id);
              })
              .catch(err => {
                this.$notify({
                  timeout: 5000,
                  message: err.message,
                  type: "error",
                  horizontalAlign: "right",
                  verticalAlign: "top",
                });
              });
        }
      })
    },
    calculateTimeInSeconds() {
      const h = (this.duration.hours||0) * 3600;
      const m = (this.duration.minutes||0) * 60;
      const s = (this.duration.seconds||0) * 1;

      return h + m + s;
    },
  },
};
</script>
<style lang="scss">
@import '~vue-datetime/dist/vue-datetime.css';
.joined::before {
  content: 'Angemeldet';
  height: 100px;
  width: 300px;
  position: absolute;
  top: 30px;
  right: -60px;
  z-index: 100;
  background: transparent;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  font-size: 4rem;
  text-align: center;
  vertical-align: middle;
  color: red;
  font-family: 'Big Shoulders Stencil Text', cursive;
}
.joined.finished::before {
  content: 'Beendet';
}
.md-collapse-label .md-collapse-title {
  font-size: 1.5625rem;
  line-height: 1.4em;
}

.picture {
  background-color: #999999;
  border: 4px solid #cccccc;
  color: #ffffff;
  margin-top: 15px;
  margin-bottom: 15px;
  overflow: hidden;
  transition: all 0.2s;
  -webkit-transition: all 0.2s;
  /* display: inline-block; */
  max-width: 150px;
}
.tempo-value {
  font-size: 14px;
  border-bottom: 1px solid #d2d2d2;
}
.tempo-label {
  font-size: 12px;
  color: #b6b6b6;
}
.md-dialog-actions {
  margin: 8px 16px;
}
.error {
  color: #f4473b !important;
}
.success {
  color: #71bf78 !important;
}
.image {
  display: flex;
  input {
    display: flex;
    align-self: flex-end;
  }
  .image-info {
    display: flex;
    flex-direction: column;
    font-size: 15px;
    align-items: baseline;
  }
}

// .public-challenge-title {
//   display: flex;
//   align-items: center;
//   i {
//     color: #DF263B;
//     width: 24px;
//     height: 24px;
//     font-size: 14px;
//     padding: 4px;
//     background: rgba(223, 38, 59, 0.12);
//     margin-right: 12px;
//   }
// }
// .challenge-date-time {
//   display: flex;
//   //height: 100% !important;
//   .vdatetime {
//     flex: 1 1 auto;
//     input {
//       width: 100%;
//       height: 50px !important;
//     }
//   }
// }

.edit-challenge-modal {
  .modal-container {
    max-height: calc(100vh - 60px);
    position: relative;
    top: -28px;
    display: flex;
    flex-direction: column;
  }
  .modal-body {
    //max-height: 80vh;
    height: 100%;
    overflow-y: auto;
  }
  .cancel-button {
    margin-right: 10px;
  }
}
.validate-icons {
  position: relative;
  left: calc(100% - 30px);
  top: -40px;
}
.dots {
  display: flex;
  align-items: center;
  &.bold {
    padding: 10px 15px 0 0px;
    font-weight: 400;
    min-width: 130px;
    justify-content: flex-end;
  }
  &.description-info {
    font-size: 14px;
    padding-top: 10px;
  }
  &.fixed-container {
    min-width: 100px;
    font-weight: 400;
  }
}
.md-input {
  width: 100%;
}
.custom-style {
  padding: 0 5px !important;
}

.challenge-date-time {
  padding-right: 0;
  padding-left: 0;
  .md-field:not(.md-disabled):after {
    height: 0;
  }
}

.buttons {
  display: flex;
  justify-content: flex-end;
  padding-top: 40px;
}

.not-allowed-time {
  position: absolute;
  // margin-top: 48px;
  font-size: 12px;
  color: red;
}
// .vueperslides__arrow {
//   font-size: 30px;
//   .vueperslides__arrow--prev {
//     left: -1rem !important;
//   }
//   .vueperslides__arrow--next {
//     right: -1rem !important;
//   }
// }
@media (max-width: 1280px) {
  .image {
    flex-direction: column;
  }
}

@media (max-width: 700px) {
  .challenge-date-time {
    flex-direction: column;
    .dots {
      justify-content: flex-start;
    }
  }
  .challenge-date-time {
    margin: 0 !important;
    //max-height: 46px;
  }
  .manual-activity-modal-container {
    padding: 0 !important;
  }
}
@media (max-width: 320px) {
  .edit-challenge-modal {
    .modal-container {
      max-height: calc(100vh - 120px);
    }
  }
}

</style>
